import * as React from 'react';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { QuestionModuleDto } from '../../../pages/questionModuleTypes';
import QuestionCluster from './QuestionCluster';
import { AnsweredCatalogueDto } from '../../../pages/answeredCatalogueTypes';
import Module from '../common/Module';
import { observer } from 'mobx-react';
import { sortAsc } from '../../../util/sorting';

interface Props {
  questionModule: QuestionModuleDto,
  answeredCatalogueDto: AnsweredCatalogueDto,
  updateAnsweredCatalogue: (updatedCatalogue: AnsweredCatalogueDto) => void
}

type LocalStyles = 'cluster';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({

  cluster: {
    marginTop: theme.spacing.unit * 2,
  }
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class QuestionModule extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props);
    this.renderCluster = this.renderCluster.bind(this);
  }

  public render() {
    return (
      <Module
        questionModule={this.props.questionModule}
        renderCluster={this.renderCluster}/>
    )
  }

  private renderCluster() {
    return (
      <>
        {
          this.props.questionModule.clusters
            .slice()
            .sort((q1, q2) => sortAsc(q1, q2))
            .map(cluster => (
              <div className={this.props.classes.cluster} key={cluster.id + 'moduleCluster'}>
                <QuestionCluster key={cluster.id} questionCluster={cluster}
                                 updateAnsweredCatalogue={this.props.updateAnsweredCatalogue}
                                 answeredCatalogueDto={this.props.answeredCatalogueDto}/>
              </div>
            )
          )
        }
      </>
    )
  }
}

export default withStyles(localStyles)(QuestionModule);
